import { eventPanelTabConfigs } from "../../event-panel/tabs/components/event-panel-tabs-config";
import { DEX_LABEL, USX_LABEL } from "../constants";

export function getUniversalSearchLabel(dexNextEnabled: boolean = false) {
    return dexNextEnabled ? USX_LABEL : DEX_LABEL;
}

export function getUniversalSearchFormLabel(dexNextEnabled: boolean = false) {
    return dexNextEnabled ? USX_LABEL : `${DEX_LABEL} Forms`;
}

export function getEventPanelTabTooltip(tabName: string, dexNextEnabled: boolean = false) {
    if (tabName === eventPanelTabConfigs.DEX.name && dexNextEnabled) {
        return USX_LABEL;
    }
    return tabName;
}
